import { NgModule } from '@angular/core';
import { BaseTmsModule } from '@spartacus/tracking/tms/core';

@NgModule({
  declarations: [],
  imports: [BaseTmsModule.forRoot()],
})
export class TagManagementFeatureModule {}
